// src/components/FooterSection.jsx
import React from 'react';
import footerImage from '../assets/canarin_text_logo.png'

export default function FooterSection({profile}) {
  return (
    <div className="canario-footer">
      <a href={`https://www.canar.in?origin=canarin&username=${profile}`} target="_blank" rel="noreferrer">
        <img src={footerImage} alt="canarin"/>
      </a>
    </div>
  );
}
